export default {
    en: {
        SCOREBOARD_TITLE: 'Scoreboard',
        SCOREBOARD_ALL_TEAMS: 'All teams',
        SCOREBOARD_TOP_10_TEAMS_TITLE: 'Top 10 teams',
        SCOREBOARD_TOP_10_AND_YOUR_TEAM_TITLE: 'Top 10 teams and your team',
        SCOREBOARD_TABLE_RANK: 'Rank',
        SCOREBOARD_TABLE_TEAM: 'Team',
        SCOREBOARD_TABLE_SCORES: 'Scores',
        SCOREBOARD_TABLE_TIMESTAMP: 'Timestamp',
        SCOREBOARD_TABLE_CHANGE: 'Change',
        SCOREBOARD_TABLE_TOTAL: 'Total',
        SCOREBOARD_TABLE_EMPTY: 'The competition has no teams.',
        SCOREBOARD_CHART_EMPTY: 'No scores have been recorded.',
        SCOREBOARD_CHART_X_LABEL: "Time",
        SCOREBOARD_CHART_Y_LABEL: "Score",
        SCOREBOARD_CHART_TAB_CHART_VIEW: "Chart View",
        SCOREBOARD_CHART_TAB_TABLE_VIEW: "Table View",
        SCOREBOARD_ERROR: 'Could not show the scoreboard at the moment.',
        SCOREBOARD_UPDATE: 'Updating...',
        SCOREBOARD_EXPORT: 'Export Submissions',
        SCOREBOARD_HIDDEN_ALERT_TEXT: 'This scoreboard is currently only visible to competition admins.',

        SCOREBOARD_SUMMARY_TITLE: "Scoreboard summary",
        SCOREBOARD_SUMMARY_NO_DATA: "No score data yet.",
        SCOREBOARD_SUMMARY_LEADER_SINGLE: "{team} leads with {points} points as of {asOf}.",
        SCOREBOARD_SUMMARY_LEADER_TIE: "{teams} are tied for the lead with {points} points as of {asOf}.",
        SCOREBOARD_SUMMARY_LAST_MOVE_NONE: "No score changes since the previous update.",
        SCOREBOARD_SUMMARY_LAST_MOVE_POSITIVE: "No score changes since the previous update. | {team} gained {points} point in the last update. | {team} gained {points} points in the last update.",
        SCOREBOARD_SUMMARY_LAST_MOVE_NEGATIVE: "No score changes since the previous update. | {team} lost {points} point in the last update. | {team} lost {points} points in the last update.",
        SCOREBOARD_SUMMARY_CLIMB_SOME: "{team} climbed from rank {fromRank} to {toRank} {window}.",
        SCOREBOARD_SUMMARY_DROP_SOME: "{team} dropped from rank {fromRank} to {toRank} {window}.",
        SCOREBOARD_SUMMARY_NO_RANK_CHANGE: "No team changed position in the last update.",
        SCOREBOARD_SUMMARY_STREAK_SOME_SINGLE: "{team} has led for the last 0 updates. | {team} has led for the last {n} update. | {team} has led for the last {n} updates.",
        SCOREBOARD_SUMMARY_STREAK_SOME_MULTI: "{teams} have led for the last 0 updates. | {teams} have led for the last {n} update. | {teams} have led for the last {n} updates.",
        SCOREBOARD_SUMMARY_WINDOW_SUFFIX: " in the last 0 updates | in the last {n} update | in the last {n} updates",
    }
};
